//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/MBD.js";
import "../no/Object.js";
import "../no/ugmath.js";
import "../no/Session.js";
let d=[[],[[["angularDimensionTag","numComponents","components","intersectionPoint","mappingRequired"],"GetAngularComponents",{},1,0],[["angularDimensionTag","location"],"InferAngularDimensionSupplementaryAngle",{},2,0],[["workView","geom","matrix","arcSize","units","arcCenter","canInfer"],"GetInferCylTypeInput",{},3,0],[["builder","newOrigin","deleteOldDimension","doUpdate"],"RecreateBuilderDimensionFromOriginInfer",{R_:{newDimension:"NXObject"}},4,0]],[]];
SPLM.MBD.WebAnnotations = class extends SPLM.Object{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.MBD.WebAnnotations";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.MBD.AngularComponents = class{
    constructor(start_pt,end_pt,modifier){
        this.start_pt=start_pt;this.end_pt=end_pt;this.modifier=modifier;}
    get StartPt(){if(this.start_pt === undefined) this.start_pt = new SPLM.Point3d(); return this.start_pt}
    set StartPt(val){this.start_pt = val}
    get EndPt(){if(this.end_pt === undefined) this.end_pt = new SPLM.Point3d(); return this.end_pt}
    set EndPt(val){this.end_pt = val}
    get Modifier(){return this.modifier}
    set Modifier(val){this.modifier = val}
};

SPLM.MBD.AngularComponent = class{
    constructor(start_pt,end_pt,modifier){
        this.start_pt=start_pt;this.end_pt=end_pt;this.modifier=modifier;}
    get StartPt(){if(this.start_pt === undefined) this.start_pt = new SPLM.Point3d(); return this.start_pt}
    set StartPt(val){this.start_pt = val}
    get EndPt(){if(this.end_pt === undefined) this.end_pt = new SPLM.Point3d(); return this.end_pt}
    set EndPt(val){this.end_pt = val}
    get Modifier(){return this.modifier}
    set Modifier(val){this.modifier = val}
};

SPLM.MBD.MbdWebAnnotationsLinearModifier = Object.freeze({
    "Start" : "Start", "End" : "End"});

export default SPLM;